export default __webpack_public_path__ + "static/media/whatsapp-open.d611dd95.svg";